import React from "react";
import { useNavigate } from "react-router-dom";
import { useShop } from "../context/ShopContext";

const ProductCard = ({ p }) => {
  const { addToCart } = useShop();
  const navigate = useNavigate();
  return (
    <div className="relative bg-white border border-gray-100 rounded-xl p-3 flex flex-col hover:shadow-xl hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300">
      <span className="absolute top-2 right-2 bg-[#12a150] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full z-10">
        {p.off}% OFF
      </span>
      <div
        onClick={() => navigate(`/product/${p.id}`)}
        className="h-24 sm:h-28 flex items-center justify-center mb-2 overflow-hidden rounded-lg cursor-pointer"
      >
        <img
          src={p.img}
          alt={p.name}
          loading="lazy"
          className="h-full w-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div
        onClick={() => navigate(`/product/${p.id}`)}
        className="text-[13px] font-semibold text-gray-800 leading-tight truncate cursor-pointer hover:text-[#0e7a3d]"
      >
        {p.name}
      </div>
      <div className="text-[11px] text-gray-400 mb-1.5">{p.brand}</div>
      <div className="flex items-baseline gap-1.5 mb-2.5">
        <span className="text-[14px] font-bold text-[#0e7a3d]">₹ {p.price.toFixed(2)}</span>
        <span className="text-[11px] text-gray-400 line-through">₹ {p.mrp.toFixed(2)}</span>
      </div>
      <button
        onClick={() => addToCart(p)}
        className="mt-auto w-full bg-[#12a150] hover:bg-[#0d8a40] active:scale-[0.98] text-white text-[12px] font-semibold rounded-full py-2 transition-[background-color,transform]"
      >
        Add to Cart
      </button>
    </div>
  );
};

export default ProductCard;
